import React, { useState } from 'react';
import { Props_SnippetMediaContent } from './MediaContent.props';
import SharedHeading from '../Shared/Heading/Heading';
 import SnippetLink from '../Shared/Link/Link';
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler';

const MediaContent = (props: Props_SnippetMediaContent) => {
  const { snippetStyle,heading, content, media, repeatable_links, links } = props;
  const [playing, setPlaying] = useState(false);

  const videoSrc = media.videoSrc?.value;
  const thumbnail = media.thumbnail?.value;
  const thumbnailAlt = media.thumbnailAlt?.value || '';
  const hasVideo = Boolean(videoSrc);
  const linkAlignmentClass = links?.alignment?.value
    ? `snippet-media-content__links-container--${links.alignment.value}`
    : '';
  const positionClass = content?.position?.value
    ? `snippet-media-content--${content.position.value}`
    : 'snippet-media-content--right';

    const snippetStyleClass = snippetStyle?.style.value
    ? `snippet-media-content--${snippetStyle.style.value}`
    : 'snippet-media-content--default';

    const backgroundStyleClass = content?.backgroundStyle?.value
    ? `snippet-media-content--${content.backgroundStyle.value}`
    : 'snippet-media-content--transparent';

  // Helper to process YouTube/Vimeo URLs for embedding with autoplay
  const processUrl = (url: string): string => {
    let newUrl = url;
    if (url.includes('watch?v=')) {
      newUrl = url.replace('watch?v=', 'embed/');
    } else if (url.includes('youtu.be')) {
      newUrl = url.replace('youtu.be/', 'youtube.com/embed/');
    }
    if (url.includes('vimeo.com')) {
      const match = url.match(/vimeo\.com\/(\d+)/);
      if (match) {
        newUrl = `https://player.vimeo.com/video/${match[1]}`;
      }
      // Vimeo autoplay param
      if (!newUrl.includes('autoplay=1')) {
        newUrl += (newUrl.includes('?') ? '&' : '?') + 'autoplay=1';
      }
    } else if (newUrl.includes('youtube.com/embed/')) {
      // YouTube autoplay param
      if (!newUrl.includes('autoplay=1')) {
        newUrl += (newUrl.includes('?') ? '&' : '?') + 'autoplay=1';
      }
    }
    return newUrl;
  };

  return (
    <section className={`snippet-media-content ${positionClass} ${snippetStyleClass} ${backgroundStyleClass}`}>
      <div className="snippet-media-content__container">
        <div className="snippet-media-content__media-section">
          {thumbnail && (
            <figure className="snippet-media-content__thumbnail-container">
              <img
                src={thumbnail}
                alt={thumbnailAlt}
                className="snippet-media-content__thumbnail"
                loading="lazy"
              />
              {hasVideo && !playing && (
                <button
                  className="snippet-media-content__play-button attrax-button-play-white"
                  aria-label="Play video"
                  onClick={() => setPlaying(true)}
                  type="button"
                />
              )}
              {hasVideo && playing && videoSrc && (
                <iframe
                  className="snippet-media-content__video"
                  width="560"
                  height="315"
                  src={processUrl(videoSrc)}
                  title="Embedded video player"
                  loading="lazy"
                  allow="autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen={true}
                ></iframe>
              )}
            </figure>
          )}
        </div>
        <div className={`snippet-media-content__text-section`}>
          <SharedHeading
            className="snippet-media-content__heading"
            level={heading.level?.value as 'h1'|'h2'|'h3'|'h4'|'h5'|'h6' || 'h2'}
            alignment={heading.alignment?.value as 'start'|'center'|'end'}
            visibility={typeof heading.visibility?.value === 'boolean' ? heading.visibility.value : heading.visibility?.value === 'true'}
          >
            {heading.text?.value}
          </SharedHeading>
          {content?.text?.value && (
            <div className="snippet-media-content__text">{CompileMarkdown(content.text.value)}</div>
          )}

          <div className={`snippet-media-content__links-container ${linkAlignmentClass}`}>
            {repeatable_links?.map((link, index) => (
              link.linkText?.value && link.linkHref?.value && (
                <SnippetLink
                  key={index}
                  className="snippet-media-content__link attrax-button"
                  url={link.linkHref.value}
                  openInNewTab={typeof link.linkTarget?.value === 'boolean' ? link.linkTarget.value : link.linkTarget?.value === 'true'}
                  linkStyles={link.linkStyle?.value}
                >
                  {link.linkText.value}
                </SnippetLink>
              )
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MediaContent;
